module.exports = __webpack_public_path__ + "img/atz-hypatia.ee3b328a.svg";